import Vue from 'vue'
import account from '../store/modules/account.module/account.module'
import VueRouter from 'vue-router'
import Login from '../views/Login.vue'
import ForwardHome from '../views/ForwardHome.vue'

Vue.use(VueRouter)

const routes = [
  // #region Forward Traveler
  {
    path: '/',
    redirect: '/page1',
    name: 'forwardHome',
    component: ForwardHome,
    children: [
      {
        path: '/page1',
        name: 'page1',
        component: () => import('../components/ForwardPage1.vue')
      },
      {
        path: '/page2',
        name: 'page2',
        component: () => import('../components/ForwardPage2.vue')
      },
      {
        path: '/page3',
        name: 'page3',
        component: () => import('../components/ForwardPage3.vue')
      }
    ]
  },
  // #endregion

  // #region Forward Agent/Member
  {
    path: '/member0',
    redirect: '/memberp1',
    name: 'memberhome',
    component: ForwardHome,
    children: [
      {
        path: '/memberp1',
        name: 'memberp1',
        component: () => import('../components/ForwardPage1.vue')
      },
      {
        path: '/memberp2',
        name: 'memberp2',
        component: () => import('../components/ForwardPage2.vue')
      },
      {
        path: '/memberp3',
        name: 'memberp3',
        component: () => import('../components/ForwardPage3.vue')
      }
    ]
  },
  // #endregion

  // #region Backend Admin/Agent
  {
    path: '/adminLogin',
    name: 'adminLogin',
    component: Login
  },
  {
    path: '/agentLogin',
    name: 'agentLogin',
    component: Login
  },
  {
    path: '/home',
    name: 'home',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ '../views/AdminBackend.vue'),
    meta: {
      requiresAuth: true
    },
    children: [
      {
        path: '/system',
        name: 'system',
        component: () => import('../components/System.vue')
      },
      {
        path: '/addone',
        name: 'addone',
        component: () => import('../components/AddOne.vue')
      },
      {
        path: '/addonelist',
        name: 'addonelist',
        component: () => import('../components/AddOneList.vue')
      },
      {
        path: '/admin',
        name: 'admin',
        component: () => import('../components/Admin.vue')
      },
      {
        path: '/agent',
        name: 'agent',
        component: () => import('../components/Agent.vue')
      },
      {
        path: '/member',
        name: 'member',
        component: () => import('../components/Member.vue')
      },
      {
        path: '/group',
        name: 'group',
        component: () => import('../components/Group.vue')
      },
      {
        path: '/groupdetail',
        name: 'groupdetail',
        component: () => import('../components/GroupDetail.vue')
      },
      {
        path: '/board',
        name: 'board',
        component: () => import('../components/Board.vue')
      },
      {
        path: '/quote',
        name: 'quote',
        component: () => import('../components/Quote.vue')
      },
      {
        path: '/mregister',
        name: 'mregister',
        component: () => import('../components/MemberRegister.vue')
      }
    ]
  }
  // #endregion
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

// eslint-disable-next-line no-unused-vars
router.beforeEach((to, from, next) => {
  // eslint-disable-next-line no-console
  // if (process.env.NODE_ENV === 'development') console.log('T1', account)
  // console.log("T1", to.matched.some(record => { console.log(record); }));
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!account.state.status.loggedIn) {
      next({
        path: '/'
        // query: { redirect: to.fullPath }
      })
    } else {
      next()
    }
  } else if (account.state.status2.loggedIn) {
    // eslint-disable-next-line prettier/prettier
    if (to.path !== '/memberp1' && to.path !== '/memberp2' && to.path !== '/memberp3') {
      next({ path: '/memberp1' })
    } else {
      next()
    }
  } else {
    next()
  }
})

export default router
